_ = require 'underscore'
{ PowerUp, PowerUpItemType } = require 'common/components/power-up'
$ = require 'jquery'
Analytics = require('common/debug/behavioral-analytics').default
Auth = require 'db/auth'
BaseDirectoryView = require './base-directory-view'
BoardAddToTeam = require 'views/board-menu/board-add-to-team-view'
BusinessClassUpsellView = require 'views/directory/business-class-upsell-view'
ClientConfig = require 'debug/client-config'
Confirm = require 'views/lib/confirm'
Controller = require 'controller'
CustomFieldsButtonView = require 'views/custom-field/custom-fields-button-view'
defaultPowerUpIcon = require 'images/directory/icons/customIcon.png'
directoryLegacyPowerUps = require './directory-legacy-power-ups'
Format = require 'lib/markdown/format'
l = require 'lib/localize'
ModelLoader = require 'db/model-loader'
PluginIO = require 'views/internal/plugins/plugin-io'
PluginIOCache = require 'views/internal/plugins/plugin-io-cache'
PluginRunner = require 'views/internal/plugins/plugin-runner'
pluginsChangedSignal = require 'views/internal/plugins/plugins-changed-signal'
PopOver = require 'views/lib/pop-over'
Promise = require 'bluebird'
React = require 'react'
t = require('views/internal/recup-with-helpers')('directory_power_up_item')
trackUe = require 'debug/trackUe'
Util = require 'lib/util'
View = require 'view'
xtend = require 'xtend'

CUSTOM_FIELDS_ID = require 'data/custom-fields-id'

{ PowerUpTestIds } = require '@trello/webdriverio-tests'

powerUpSettings = t.renderable ({ authorize, disable, supportsSettings, showSettings, supportsAuth, hasPersonalSettings, removeData, authStatus, showListingOption, navigateToListing }) ->
  t.ul '.pop-over-list', ->
    if showListingOption
      t.li onClick: navigateToListing, ->
        t.a ->
          t.format 'view-power-up'
    if supportsAuth && authStatus && !authStatus.authorized
      t.li onClick: authorize, ->
        t.a ->
          t.format 'authorize-account'
    else
      if supportsSettings
        t.li onClick: showSettings, ->
          t.a ->
            t.format 'edit-power-up-settings'
      if hasPersonalSettings
        t.li onClick: removeData, ->
          t.a ->
            t.format 'remove-personal-settings'
    t.li 'data-test-id': PowerUpTestIds.DisablePowerUpLink, onClick: disable, ->
      t.a ->
        t.format 'disable'

enableButton = t.renderable ({ onClick }) ->
  t.button '.button.primary.directory-enable-button', { onClick }, ->
    t.formatText 'add'

disabledButton = t.renderable ({ enterpriseDisplayName }) ->
  title = t.l 'this-power-up-was-disabled-by-the-enterprise', { enterpriseDisplayName }
  t.button '.button.primary.directory-disabled-button.disabled', { title }, ->
    t.formatText 'disabled'

settingsButton = t.renderable ({ onClick }) ->
  t.a '.button-link.icon-lg.icon-gear.directory-settings-button', { onClick }

module.exports = class DirectoryPluginItemView extends BaseDirectoryView
  className: 'directory-listing-powerup'

  initialize: ({ @plugin, @currentPage, @directoryView }) ->
    super
    @canEnable = @model.editable()

    @initialData =
      canEnable: @model.editable()
      isLegacy: @plugin.id in _.pluck(directoryLegacyPowerUps, 'id')

    @io = PluginIOCache.get(@plugin)

    @pluginDetails =
      displayName: @io.getName()
      description: @io.getDescription()
      iconUrl: @io.getIconUrl()
      overview: @io.getOverview()
      author: @plugin.get('author')
      moderatedState: @plugin.get('moderatedState')

    if @initialData.isLegacy
      legacyPlugin = _.findWhere directoryLegacyPowerUps, { id: @plugin.id }
      @pluginDetails = xtend @pluginDetails, legacyPlugin

    @listenTo @model, 'change:idOrganization change:powerUps', @frameDebounce @render
    @listenTo @model.boardPluginList, 'add remove reset', @frameDebounce @render
    @listenTo @model, 'cancel-add-to-team', -> PopOver.hide()
    @subscribe @model.boardPluginList.snoop(), @frameDebounce @render
    @subscribe pluginsChangedSignal(@model), @frameDebounce @render

  events:
    'click': (e) ->
      if !@$(e.target).is('a, button')
        Analytics.sendUIEvent
          action: 'clicked'
          actionSubject: 'card'
          actionSubjectId: 'powerUpCard'
          attributes: _.extend({
            objectId: @plugin.id
            objectType: 'powerUp'
          }, @directoryView.getCommonTrackingAttributes())
          source: 'boardDirectory' # Will need to figure out the exact screen here
      @navigateToListing(e)

  showListingOption: -> false

  navigateToListing: (e) ->
    if !@$(e.target).is('a, button')
      if PopOver.isVisible
        PopOver.hide()

      @directoryView?.navigate({ idPlugin: @plugin.id })

  enable: (e) ->
    Util.stop(e)
    elem = e.target

    # Enable the Power-Up for the board.
    if @model.canEnableAdditionalPowerUps()
      if @plugin.get('idOrganizationOwner') == window.firstPartyPluginsOrg
        @model.enablePlugin(@plugin.id)

        if @io.supports('on-enable')
          PluginRunner.one
            plugin: @plugin
            command: 'on-enable'
            board: @model
            el: elem
          .catch (err) =>
            console?.warn('Failed to handle on-enable command.', {
              error: err.message,
              id: @plugin.id
            })

        Analytics.sendTrackEvent
          action: 'added'
          actionSubject: 'powerUp'
          attributes: xtend @directoryView.getCommonTrackingAttributes(),
            powerUpName: if @plugin.get('public') then @io.getName() else undefined
          objectType: 'powerUp'
          objectId: @plugin.id
          source: 'addPowerUpButton'

        trackUe(@currentPage, 'enables', 'Power-Up', '', '', 'enable button', @plugin.id)

      else
        @directoryView.navigate({ idPlugin: @plugin.id, isEnabling: true })
    else
      if @model.hasOrganization()
        upgradeUrl = Controller.getBoardPowerUpsUpgradeUrl(@model)

      # Redirect to the Business Class page if the user doesn't own the board.
      if !@model.owned()
        upgradeUrl = '/business-class'

      # Show business class ad.
      PopOver.toggle
        autoPosition: true
        hideHeader: true
        elem: elem
        view: new BusinessClassUpsellView({ @model })
        displayType: 'directory-business-class-popover'

    return

  isGrandfathered: ->
    @initialData.isLegacy && @pluginDetails.name in @model.get('powerUps')

  disable: (elem) ->
    if @isGrandfathered()
      removePowerUp = =>
        @model.pull('powerUps', @pluginDetails.name)

      if @model.getOrganization()?.isFeatureEnabled('plugins')
        removePowerUp()
      else
        Confirm.pushView 'disable power up',
          elem: elem
          model: @model
          confirmBtnClass: 'negate'
          fxConfirm: removePowerUp
    else
      if @io.supports('on-disable')
        PluginRunner.one
          plugin: @plugin
          command: 'on-disable'
          board: @model
          timeout: 500
        .finally =>
          @model.disablePlugin(@plugin.id)
      else
        @model.disablePlugin(@plugin.id)

    if @directoryView
      Analytics.sendTrackEvent
        action: 'disabled'
        actionSubject: 'powerUp'
        attributes: @directoryView.getCommonTrackingAttributes()
        objectType: 'powerUp'
        objectId: @plugin.id
        source: 'powerUpConfigInlineDialog'

    trackUe(@currentPage, 'disables', 'Power-Up', '', '', 'disable button', @plugin.id)

  getEnabledState: ->
    if @initialData.isLegacy
      @model.isPowerUpEnabled(@pluginDetails.name)
    else
      @model.isPluginEnabled(@plugin.id)

  hasPersonalSettings: ->
    pluginData = _.extend Auth.me().getPluginData(@plugin.id), @model.getPluginData(@plugin.id)
    _.any pluginData, ({ private: privateData }) -> privateData?

  showPowerUpSettings: (elem) ->
    trackUe(@currentPage, 'opens', 'Power-Up', '', '', 'edit-settings', @plugin.id)

    if @directoryView
      @directoryView.trackScreenEvent 'powerUpEditInlineDialog',
        powerUpId: @plugin.id

    if @initialData.isLegacy
      PopOver.pushView
        elem: elem
        view: @pluginDetails.settingsView(@model)
        autoPosition: true
    else if @plugin.id == CUSTOM_FIELDS_ID
      PopOver.pushView
        elem: elem
        view: CustomFieldsButtonView
        autoPosition: true
        options: { board: @model }
    else
      PluginRunner.one
        plugin: @plugin
        command: 'show-settings'
        board: @model
        el: elem
      .catch (err) =>
        console?.warn('Failed to handle show-settings.', {
          error: err.message,
          id: @plugin.id
        })
      .done()

    return

  showAuthorization: (elem) ->
    trackUe(@currentPage, 'opens', 'Power-Up', '', '', 'show-authorization', @plugin.id)
    PluginRunner.one
      plugin: @plugin
      command: 'show-authorization'
      board: @model
      el: elem
    .catch (err) =>
      console?.warn('Failed to handle show-authorization.', {
        error: err.message,
        id: @plugin.id
      })
    .done()
    return

  clearData: (elem) ->
    Confirm.pushView 'clear plugin data',
      elem: elem
      model: @model
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        trackUe(@currentPage, 'clicks', 'Power-Up', '', '', 'remove-data', @plugin.id)
        if @io.supports('remove-data')
          PluginRunner.one
            board: @model
            plugin: @plugin
            command: 'remove-data'
            timeout: 1000
          .finally =>
            @model.clearPluginData(@plugin.id)
            Auth.me().clearPluginData(@plugin.id)
        else
          @model.clearPluginData(@plugin.id)
          Auth.me().clearPluginData(@plugin.id)
    return

  toggleOptions: (e) ->
    Util.stop(e)
    elem = e.target

    bindElemAction = (action) => _.bind(action, @, elem)

    trackUe(@currentPage, 'opens', 'Power-Up', '', '', 'show-settings', @plugin.id)

    if @directoryView
      @directoryView.trackScreenEvent 'powerUpConfigInlineDialog',
        powerUpId: @plugin.id

    Promise.props
      supportsAuth: @io.supports('show-authorization')
      supportsSettings: @pluginDetails.settingsView || @io.supports('show-settings')
      hasPersonalSettings: @hasPersonalSettings()
    .then (data) =>
      if data.supportsAuth
        return PluginRunner.one
          timeout: 1000
          plugin: @plugin
          command: 'authorization-status'
          board: @model
        .then (authStatus) ->
          xtend data, { authStatus: authStatus }
        .catch (err) =>
          console?.warn('Failed to get authorization-status.', {
            error: err.message,
            id: @plugin.id
          })
          return data
      return data
    .then (data) =>
      PopOver.toggle
        autoPosition: true
        getViewTitle: => @io.getName()
        elem: elem
        reactElement: React.createElement powerUpSettings, {
          key: @plugin.id
          disable: (e) =>
            PopOver.hide()
            @disable(e)
          authorize: bindElemAction @showAuthorization
          showSettings: bindElemAction @showPowerUpSettings
          removeData: bindElemAction(@clearData)
          supportsSettings: data.supportsSettings
          supportsAuth: data.supportsAuth
          hasPersonalSettings: data.hasPersonalSettings
          authStatus: data.authStatus
          showListingOption: @showListingOption()
          navigateToListing: bindElemAction @navigateToListing
        }

  getButton: (powerUpItemType) ->
    # for desktop, we can't upsell members, so we hide the
    # "Enable" button if the member can't enable more power-ups
    if ClientConfig.get('dontUpsell') && !@model.canEnableAdditionalPowerUps() && !@isEnabled
      return

    # If the board is an enterprise board and the enterprise doesn't allow
    # the plugin to be enabled, show the disabled button.
    if @model.isEnterpriseBoard() && @model.getEnterprise()? && !@model.getEnterprise().isPluginAllowed(@plugin.id)
      return React.createElement disabledButton, {
        enterpriseDisplayName: @model.getEnterprise()?.get('displayName')
      }

    eventSource = 'powerUpCard'
    if powerUpItemType == PowerUpItemType.Basic
      eventSource = 'boardDirectoryPowerUpDetailsScreen'

    if @isEnabled
      return React.createElement settingsButton, {
        onClick: ((e) =>
          Analytics.sendUIEvent
            action: 'clicked'
            actionSubject: 'button'
            actionSubjectId: 'powerUpEditButton'
            attributes: _.extend({
              objectId: @plugin.id
              objectType: 'powerUp'
            }, @directoryView.getCommonTrackingAttributes())
            source: eventSource
          @toggleOptions(e)
        )
      }

    return React.createElement enableButton, {
      onClick: ((e) =>
        Analytics.sendUIEvent
          action: 'clicked'
          actionSubject: 'button'
          actionSubjectId: 'powerUpAddButton'
          attributes: _.extend({
            objectId: @plugin.id
            objectType: 'powerUp'
          }, @directoryView.getCommonTrackingAttributes())
          source: eventSource
        @enable(e)
      )
    }

  renderContent: ->
    { author, iconUrl, displayName, description, overview } = @pluginDetails
    @isEnabled = @getEnabledState({ id: @plugin.id })
    atomType = @options.atomType || PowerUpItemType.Basic

    React.createElement PowerUp, {
      type: atomType
      atomProps:
        subtitle: if atomType == PowerUpItemType.Basic then author
        overview: Format.markdownAsText(overview || description)
        icon:
          url: iconUrl || defaultPowerUpIcon
        heroImageUrl: @plugin.get('heroImageUrl')
        name: displayName
        button: @getButton(atomType)
    }

  render: ->
    super
    @$el.data('idPlugin', @plugin.id)
    @



// WEBPACK FOOTER //
// ./app/scripts/views/directory/directory-plugin-item-view.coffee